<app-breadcrumb currentPage="About Us"></app-breadcrumb>
<section class="about-main">
  <div class="container about-grid">
    <div><img src="assets/img/about/about-tech.jpg" alt="SPLEX Innovation digital team" class="about-photo"></div>
    <div class="about-copy">
      <h2>Your Technology Partner From Idea to Ongoing Growth.</h2>
      <p>SPLEX INNOVATION is a technology solutions company helping businesses design, build, modernize, and maintain
        digital products that create real business value.</p>
      <p>From professional websites and custom applications to SaaS platforms and ongoing technical support, we combine
        thoughtful design, modern engineering, and practical technology to create solutions that work for your business.
      </p>
      <p>Our approach is simple: understand your business, build the right solution, and remain available as your
        technology needs evolve.</p>
      <a routerLink="/contactus" class="btn-primary-red">Work With Us <i class="bi bi-arrow-right ms-2"></i></a>
    </div>
  </div>
</section>

<section class="services-main">
  <div class="container">
    <div class="section-title"><span class="eyebrow">OUR APPROACH</span>
      <!-- <h2>Build. Innovate. Grow.</h2> -->
    </div>
    <div class="service-list m-b-25">
      <span>Build</span>
      <span>Innovate</span>
      <span>Grow</span>
    </div>
    <div class="service-grid2 m-t-25">
      <article class="service-card"><span class="icon">01</span>
        <h3>Build</h3>
        <p>Turn ideas and requirements into reliable digital solutions.</p>
      </article>
      <article class="service-card"><span class="icon">02</span>
        <h3>Innovate</h3>
        <p>Improve processes, experiences, and existing technology through practical innovation.</p>
      </article>
      <article class="service-card"><span class="icon">03</span>
        <h3>Grow</h3>
        <p>Support, maintain, and continuously improve your technology as your business evolves.</p>
      </article>
    </div>
  </div>
</section>

<section class="values-section">
  <div class="container">
    <div class="section-title"><span class="eyebrow">WHAT WE BELIEVE</span>
      <h2 class="m-b-0">Technology Should Solve Problems, Not Create Them.</h2>
    </div>
    <p>We believe technology should be practical, reliable, scalable, and aligned with your business goals.</p>
    <div class="about-copy">
      <ul class="m-t-0">
        <li><i class="bi bi-check2-circle"></i> Customer Focus</li>
        <p>Understanding your business before building the solution.</p>
        <li><i class="bi bi-check2-circle"></i> Practical Solutions</li>
        <p>Choosing the right technology for the actual problem.</p>
        <li><i class="bi bi-check2-circle"></i> Reliable Delivery</li>
        <p>Building maintainable solutions designed for long-term use.</p>
        <li><i class="bi bi-check2-circle"></i> Long-Term Partnership</li>
        <p>Supporting your technology beyond the initial launch.</p>
      </ul>
    </div>
  </div>
</section>

<section class="values-section p-t-0">
  <div class="container">
    <div class="section-title"><span class="eyebrow">OUR CAPABILITIES</span>
      <h2 class="m-b-0">From Digital Ideas to Long-Term Technology Support</h2>
    </div>
    <div class="about-copy">
      <ul class="m-t-0">
        <li><i class="bi bi-check2-circle"></i> Web & Digital Solutions</li>
        <p> Websites and digital experiences.</p>
        <li><i class="bi bi-check2-circle"></i> Software & Application Development</li>
        <p>Custom applications, SaaS, APIs and integrations.</p>
        <li><i class="bi bi-check2-circle"></i> Support & Maintenance</li>
        <p>Ongoing technical support and application maintenance.</p>
        <li><i class="bi bi-check2-circle"></i>Technology Consulting</li>
        <p>Practical technology guidance and solution planning.</p>
      </ul>
      <!-- <a routerLink="/aboutus" class="text-link">Discover SPLEX Innovation <i class="bi bi-arrow-right"></i></a> -->
    </div>
  </div>
</section>

<section class="cta-section">
  <div class="container cta-inner">
    <div><span class="eyebrow">Final CTA</span>
      <h2>Have an Idea? Let's Build It Together.</h2>
      <p>Whether you're starting something new, improving an existing application, or looking for a technology partner
        to support your business, we'd like to understand what you're trying to achieve.</p>
    </div>
    <!-- <a routerLink="/contactus" class="btn-primary-red">Talk to Our Team<i class="bi bi-arrow-right ms-2"></i></a> -->
  </div>
</section>